export enum SyncConversationsEnum {
  HIDDEN = 'HIDDEN',
  QUESTION = 'QUESTION',
  OMIT = 'OMIT',
  SELECTING = 'SELECTING',
  SYNCING = 'SYNCING',
  CANCEL_SYNC = 'CANCEL_SYNC',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  INTERNET_ERROR = 'INTERNET_ERROR',
  PROGRESS_TOASTER = 'PROGRESS_TOASTER',
}
